import { render } from "./RatingView.vue?vue&type=template&id=a776525e"
import script from "./RatingView.vue?vue&type=script&lang=js"
export * from "./RatingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__